import Field from './Field';

const fields = document.querySelectorAll('.c-form__field--fl');

for (let i = 0; i < fields.length; i++) {
  const field = new Field(fields[i], fields[i].querySelector('.c-form__input, .c-form__textarea'));
  field.mount();
}
